<template>
    <div>
        <div class="content">
            <!-- {{content}} -->
        </div>
    </div>
</template>

<script>
// import { userAgreement } from "@/api/login";
export default {
    data() {
        return {
            content:''
        }
    },
    mounted() {
        // this.requestUserAgreement()
    },
    methods:{
    // 请求用户协议
    //  requestUserAgreement() {
    //     userAgreement().then(res=>{
    //       console.log(res)
    //     //   this.content = res.data.content
    //     })
    //  }
    }
}
</script>

<style scoped lang="scss">
    .content {
        padding: 10px;
        font-size: 15px;
        text-align: left;
        line-height:1.2;
    }
</style>
